var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { key: _vm.componentKey },
    [
      _c(
        "el-upload",
        {
          staticClass: "position-relative",
          attrs: {
            action: "",
            "on-preview": _vm.handlePreview,
            "file-list": _vm.anexosfiltrados,
            limit: 2,
            "before-remove": _vm.handleRemove,
            "list-type": "picture",
            accept: "image/jpeg,image/png,application/pdf",
            "before-upload": _vm.beforeUpload
          }
        },
        [
          _c("div", { staticClass: "header-file-attachment" }, [
            _vm._v(
              "\n            " + _vm._s(_vm.tipoAnexo.descricao) + "\n        "
            )
          ]),
          _vm._v(" "),
          _c(
            "button",
            { staticClass: "card-file-attachment" },
            [
              _c("el-badge", {
                staticClass: "item card-file-attachment--dot",
                attrs: {
                  "is-dot": "",
                  type: _vm.tipoAnexo.obrigatorio ? "danger" : "primary"
                }
              }),
              _vm._v(" "),
              _c("i", {
                staticClass: "el-icon-upload card-file-attachment-icon"
              }),
              _vm._v("\n            Adicionar arquivo\n        ")
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "el-upload__tip mt-2",
              attrs: { slot: "tip" },
              slot: "tip"
            },
            [
              _c("i", { staticClass: "el-icon-warning-outline" }),
              _vm._v(
                " \n            JPG/PNG/PDF com tamanho máximo de 5Mb\n        "
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "el-drawer",
        {
          attrs: { direction: "ltr", visible: _vm.drawer, size: "80%" },
          on: {
            "update:visible": function($event) {
              _vm.drawer = $event
            }
          }
        },
        [
          _c(
            "el-row",
            { attrs: { type: "flex", justify: "center", align: "center" } },
            [
              _vm.filePreview
                ? _c("img", {
                    attrs: { src: _vm.filePreview, alt: "Imagem Carregada" }
                  })
                : _vm._e()
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "card-file-attachment-subtitles" }, [
        _c("h6", [_vm._v("Legenda:")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "card-file-attachment-subtitles-content" },
          [
            _c("el-badge", { staticClass: "item", attrs: { "is-dot": "" } }, [
              _c("div", { staticClass: "rounded border px-2 py-1" }, [
                _c("small", [_vm._v("Anexo Obrigatório")])
              ])
            ]),
            _vm._v(" "),
            _c(
              "el-badge",
              { staticClass: "item", attrs: { "is-dot": "", type: "primary" } },
              [
                _c("div", { staticClass: "rounded border px-2 py-1" }, [
                  _c("small", [_vm._v("Anexo Opcional")])
                ])
              ]
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8df5e24e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8df5e24e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/util/anexo.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-8df5e24e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/util/anexo.vue
// module chunks = 2